import { BidExtendedModel} from "./bidding_model";
import {Link} from "react-router-dom";
import {Badge} from "../ui/badge"

type bidHeaderProps = {
    bid: BidExtendedModel
}


export function BidHeader({bid} : bidHeaderProps){

    return <div className="columns-3 flex justify-between mb-4 mr-6 ml-7 text-sm text-gray-500">
        <div>
            <div>Project: <em>{bid.project?.name}</em></div>
            <div>{
                bid.scope
                    ?<div>Scope:
                        <Link
                            className="hover:underline"
                            to={`/project/${bid.project_id}/scopes/${bid.scope_id}`}>
                            <Badge variant={"outline"}>{bid.scope.title}</Badge>
                        </Link></div>
                    : " "
            }</div>
        </div>
        <div>
            <div>Prepared for: <em>{bid.project?.company_name}</em></div>
            <div>Bid: {bid.number ? <em>#{bid.number}</em>
            : <em>#1</em>}</div>

        </div>
        <div>
            <div>Prepared by: <em>{bid.company_name}</em></div>
            <div>Status: <em>{bid.status}</em> </div>
        </div>

    </div>
}